import React from 'react';
import IconSubscription from "@/assets/images/icons/16/subscription.svg";
import {Tag} from "uikit";
import "@/scss/subscribe-tag.scss";

const TicketTagSubscription = ({list = [], value = null}) => {
    if (!list || !list[value]) return null;

    return (
        <div className={"subscribe_tag"}>
            <IconSubscription/>
            <Tag type={'white'} size={'xsmall'}>
                <b>{list[value]}</b>
            </Tag>
        </div>
    );
};

export default TicketTagSubscription;
